import React, { useMemo, memo } from 'react';
import { useSlate } from 'slate-react';
import classnames from 'classnames';

import Icon from 'components/Misc/Icon';
import { twMerge } from 'tailwind-merge';

const Formula = memo(() => {
	// Get current editor
	const editor = useSlate();

	// Check if current formula is active
	const isActive = editor.isElementActive('formula');

	// Check if formula is disabled
	const isDisabled = editor.isFormulaDisabled();

	// Generate classnames
	const cls = classnames(
		isActive && 'bg-neutral-100 dark:bg-neutral-700',
		isDisabled
			? 'text-neutral-400 dark:text-neutral-700'
			: 'text-neutral-800 dark:text-white',
		'w-9 h-9 leading-9 rounded-lg text-xl text-center cursor-pointer transition-colors'
	);

	// Handles formula's button click
	// @event: object | default onClick event
	const handleFormula = event => {
		event.preventDefault();

		// Doesn't insert formula if disabled
		if (isDisabled) return;

		// Insert formula in selection
		editor.toggleFormula();
	};

	return (
		<Icon
			icon="functions"
			className={cls}
			onClick={handleFormula}
			disabled={isDisabled}
		/>
	);
});

export default Formula;
